
import Weight from "../../../assets/outline/Weight.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function WeightIcon({ className, dataTestid = "WeightIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Weight data-testid={dataTestid} className={classes} {...rest} />
  );
}
